import { get, isNil } from 'lodash';

const getAnyOrNull = (path, root) => {
  const found = get(root, path);
  return isNil(found) ? null : found;
};

// noinspection JSUnusedGlobalSymbols
export default getAnyOrNull;
